import { Wheat, TreePine, Sprout, Home, FileSearch, MessageSquare, Users, FileSignature, Instagram, Facebook, Linkedin, Youtube, Crosshair, Grape, Leaf, Flower2, Warehouse, MessageCircle, Flame, Sun } from 'lucide-react';
import { LAND_IMAGES } from './brandAssets';
import { contactInfo } from './mock';

export const navGroups = [
  { label: 'Immobilien', to: '/immobilien', testId: 'nav-immobilien' },
  {
    label: 'Flächen',
    testId: 'nav-flaechen',
    mega: true,
    intro: { kicker: 'Was verkaufen Sie?', title: 'Jede Flächenart hat ihre eigene Preislogik.', text: 'Wählen Sie Ihre Fläche – Sie landen direkt bei den Fachinformationen, passenden Angeboten und der Bewertung.' },
    feature: { image: LAND_IMAGES.bauernhof, label: 'Schwerpunkt', title: 'Bauernhöfe & Hofstellen', text: 'Hofnachfolge, Teilverkauf, Gebäudebewertung – unsere stärkste Expertise.', to: '/bauernhoefe-verkaufen' },
    columns: [
      { title: 'Landwirtschaft', items: [
        { label: 'Ackerland', to: '/ackerland-verkaufen', hint: 'Bodenpunkte, Pacht, Preislogik', icon: Wheat },
        { label: 'Grünland', to: '/gruenland-verkaufen', hint: 'Dauergrünland, Weiden, Wiesen', icon: Sprout },
        { label: 'Bauernhöfe & Hofstellen', to: '/bauernhoefe-verkaufen', hint: 'Hofnachfolge, Teilverkauf, Gebäude', icon: Home },
        { label: 'Hof mit Flächen (Gesamtpaket)', to: '/hof-mit-flaechen-verkaufen', hint: 'Betrieb komplett, Steuer, Käufer', icon: Home },
        { label: 'Rinder-, Schweine- & Reitställe', to: '/rinderstall-verkaufen', hint: 'Stall, Technik, Genehmigung', icon: Warehouse },
        { label: 'Sonderkulturen', to: '/sonderkulturen-verkaufen', hint: 'Hopfen, Obst, Beeren, Spargel', icon: Flower2 }
      ] },
      { title: 'Forst, Jagd & Besonderes', items: [
        { label: 'Wald', to: '/wald-verkaufen', hint: 'Bestand, Erschließung, Kalamität', icon: TreePine },
        { label: 'Eigenjagd', to: '/eigenjagd-verkaufen', hint: 'Revier, Pacht, Flächenstruktur', icon: Crosshair },
        { label: 'Weinberge', to: '/weinberge-verkaufen', hint: 'Lage, Rebbestand, Pflanzrechte', icon: Grape },
        { label: 'Ökopunkte & Ausgleichsflächen', to: '/oekopunkte-verkaufen', hint: 'Verkauf oder Ökokonto', icon: Leaf },
        { label: 'Biogasanlagen', to: '/biogasanlage-verkaufen', hint: 'EEG-Ende, Biomethan, Wert', icon: Warehouse }
      ] }
    ]
  },
  {
    label: 'Leistungen',
    testId: 'nav-leistungen',
    mega: true,
    intro: { kicker: 'Wie wir arbeiten', title: 'Vom ersten Gespräch bis zum Notar – ein Ansprechpartner.', text: 'Keine Floskeln, keine Inserate ohne Ihre Zustimmung. Zahlen, echte Käufer, klare Empfehlung.' },
    feature: { image: LAND_IMAGES.ackerland, label: 'Kostenlos', title: 'Flächenbewertung', text: 'Landkreis eingeben, Fläche beschreiben – Rückmeldung innerhalb von 24 Stunden.', to: '/bewertung' },
    columns: [
      { title: 'Verkaufen', items: [
        { label: 'Kostenlose Bewertung', to: '/bewertung', hint: 'Ersteinschätzung in 24 Stunden', icon: FileSearch },
        { label: 'So läuft der Verkauf', to: '/verkaufsprozess', hint: 'Ablauf, Dauer, Kosten', icon: FileSignature },
        { label: 'Bieterverfahren', to: '/bieterverfahren', hint: 'Bestpreis durch strukturierte Gebote', icon: Users },
        { label: 'Diskreter Verkauf', to: '/verkaufsprozess', hint: 'Ohne Inserat, direkt an geprüfte Käufer', icon: MessageSquare }
      ] },
      { title: 'Beratung & Nachfolge', items: [
        { label: 'Hofnachfolge & Teilverkauf', to: '/bauernhoefe-verkaufen#hofnachfolge', hint: 'Betrieb abgeben, Teilflächen lösen', icon: Warehouse },
        { label: 'Nachlass-Planer', to: '/nachlass-planer', hint: 'Behalten, verkaufen oder teilen?', icon: FileSearch },
        { label: 'Käufer-Radar', to: '/kaeufer-radar', hint: 'Gibt es Käufer für Ihre Fläche?', icon: Users },
        { label: 'Solar & Wind verpachten', to: '/solar-wind-verpachten', hint: 'Pacht-Check für PV- und Windflächen', icon: Sprout },
        { label: 'Aktuelle Preise', to: '/agrarflaechen-preise', hint: 'Orientierung nach Flächenart', icon: Wheat }
      ] }
    ]
  },
  {
    label: 'Kaufen',
    testId: 'nav-kaeufer',
    items: [
      { label: 'Aktuelle Angebote', to: '/immobilien', hint: 'Acker, Wald, Grünland, Hofstellen' },
      { label: 'Suchprofil anlegen', to: '/suchprofil', hint: 'Passende Flächen zuerst erfahren' },
      { label: 'Meine Gebote', to: '/meine-gebote' }
    ]
  },
  {
    label: 'Ratgeber',
    testId: 'nav-ratgeber',
    items: [
      { label: 'Artikel & Wissen', to: '/ratgeber' },
      { label: 'Videos', to: '/ratgeber/videos', hint: 'Kurz erklärt in 20 Sekunden' },
      { label: 'Aktuelle Preise', to: '/agrarflaechen-preise' },
      { label: 'Lexikon', to: '/ratgeber/lexikon' },
      { label: 'Downloads', to: '/ratgeber/downloads' }
    ]
  },
  { label: 'Über uns', to: '/warum-agrarkapital', testId: 'nav-warum' }
];

export const heroPromises = [
  'Kostenlos und unverbindlich',
  'Rückmeldung innerhalb von 24 Stunden',
  'Diskret – kein Inserat ohne Ihre Zustimmung'
];

export const workingPrinciples = [
  { title: 'Nur Agrarflächen', text: 'Ackerland, Wald, Grünland, Bauernhöfe und Hofstellen – darauf sind wir spezialisiert, und nur darauf.' },
  { title: 'Preis aus Fakten', text: 'Bodenpunkte, Pachtlage, Arrondierung, Erschließung und regionale Kaufpreise statt Bauchgefühl.' },
  { title: 'Ein Ansprechpartner', text: 'Andreas Heinrichs begleitet Sie persönlich von der ersten Einschätzung bis zum Notar.' },
  { title: 'Sie behalten die Kontrolle', text: 'Kein Inserat, kein Käuferkontakt und kein Termin ohne Ihre ausdrückliche Zustimmung.' }
];

export const landTypes = [
  {
    key: 'ackerland', icon: Wheat, title: 'Ackerland verkaufen', to: '/ackerland-verkaufen', image: LAND_IMAGES.ackerland,
    text: 'Bodenpunkte, Pachtverträge und Arrondierung entscheiden über den Preis. Wir kennen die Käufer im Landkreis.',
    points: ['Verpachtete Flächen verkaufbar', 'Pächter-Vorkaufsrecht geprüft', 'Teilflächen sauber getrennt']
  },
  {
    key: 'wald', icon: TreePine, title: 'Wald verkaufen', to: '/wald-verkaufen', image: LAND_IMAGES.wald,
    text: 'Bestand, Alter, Erschließung und Kalamitätsschäden bestimmen den Wert – nicht die Fläche allein.',
    points: ['Holzvorrat realistisch eingeschätzt', 'Wege und Zugang bewertet', 'Jagd und Auflagen berücksichtigt']
  },
  {
    key: 'gruenland', icon: Sprout, title: 'Grünland verkaufen', to: '/gruenland-verkaufen', image: LAND_IMAGES.gruenland,
    text: 'Dauergrünland, Weiden und Mähwiesen haben eigene Käufer und eigene Regeln. Wir ordnen das ein.',
    points: ['Umbruchverbot und Schutzgebiete geklärt', 'Pachtlogik berücksichtigt', 'Ökopunkte-Potenzial geprüft']
  },
  {
    key: 'bauernhof', icon: Home, title: 'Bauernhöfe & Hofstellen', to: '/bauernhoefe-verkaufen', image: LAND_IMAGES.bauernhof,
    text: 'Hofnachfolge, Erbfall oder Betriebsaufgabe: Wir bewerten Gebäude, Flächen und Nutzungsrechte als Ganzes – oder in sinnvollen Teilen.',
    points: ['Gesamt- oder Teilverkauf durchgerechnet', 'Wohnhaus, Ställe und Flächen getrennt bewertet', 'Käufer für Hofstellen vorgemerkt']
  }
];

export const otherTypes = [
  { label: 'Eigenjagd', to: '/eigenjagd-verkaufen', icon: Crosshair, text: 'Jagdwert, Reviergröße, Pachtverträge' },
  { label: 'Sonderkulturen', to: '/sonderkulturen-verkaufen', icon: Flower2, text: 'Hopfen, Obst, Spargel, Beeren' },
  { label: 'Weinberge', to: '/weinberge-verkaufen', icon: Grape, text: 'Lage, Rebalter, Bewirtschaftung' },
  { label: 'Ökopunkte', to: '/oekopunkte-verkaufen', icon: Leaf, text: 'Ausgleichsflächen und Handel' },
  { label: 'Biogasanlagen', to: '/biogasanlage-verkaufen', icon: Flame, text: 'EEG-Ende, Biomethan, Wert-Check' },
  { label: 'Solar & Wind verpachten', to: '/solar-wind-verpachten', icon: Sun, text: 'PV, Agri-PV, Wind – Pacht-Check' },
  { label: 'Ställe & Reitanlagen', to: '/reitanlagen-verkaufen', icon: Warehouse, text: 'Gebäude, Genehmigung, Nutzung' }
];

export const processSteps = [
  { icon: FileSearch, title: 'Eckdaten senden', text: 'Landkreis, Flächenart und Größe genügen. Unterlagen dürfen später kommen – wir helfen beim Beschaffen.' },
  { icon: MessageSquare, title: 'Ersteinschätzung', text: 'Innerhalb von 24 Stunden melden wir uns mit einer ehrlichen Einordnung – auch wenn Behalten die bessere Wahl ist.' },
  { icon: Users, title: 'Diskreter Käuferabgleich', text: 'Wir sprechen nur vorgemerkte, geprüfte Käufer an. Kein öffentliches Inserat ohne Ihr Okay.' },
  { icon: FileSignature, title: 'Sicher bis zum Notar', text: 'Verhandlung, Vertragsentwurf, Grundstücksverkehrsgesetz, Notartermin – ein Ansprechpartner bis zur Zahlung.' }
];

export const homeFaq = [
  { q: 'Was kostet die Bewertung?', a: 'Nichts. Die Ersteinschätzung ist kostenlos und unverbindlich. Eine Provision fällt nur an, wenn wir Ihre Fläche erfolgreich vermitteln.' },
  { q: 'Kann ich verpachtetes Land verkaufen?', a: 'Ja. Der Pachtvertrag geht auf den Käufer über. Wir prüfen Laufzeit, Kündigungsregeln und ein mögliches Vorkaufsrecht des Pächters – das beeinflusst Preis und Käuferkreis.' },
  { q: 'Erfährt jemand, dass ich verkaufen will?', a: 'Nur, wenn Sie es wollen. Wir arbeiten zuerst mit vorgemerkten Käufern und ohne Inserat. Nachbarn oder Pächter werden nicht ohne Ihre Zustimmung informiert.' },
  { q: 'Wie lange dauert ein Verkauf?', a: 'Von der Entscheidung bis zum Notar sind es typischerweise wenige Monate. Die Genehmigung nach Grundstücksverkehrsgesetz und die Finanzierung des Käufers bestimmen das Tempo.' },
  { q: 'Was ist, wenn Behalten besser ist?', a: 'Dann sagen wir Ihnen das. Gerade bei Erbfällen oder Hofnachfolge ist Verkaufen nicht immer die beste Lösung. Unser Nachlass-Planer hilft bei der Einordnung.' },
  { q: 'Welche Unterlagen brauche ich?', a: 'Grundbuchauszug, Flurkarte und – falls vorhanden – Pachtverträge und Bodenschätzung. Fehlt etwas, kümmern wir uns darum.' }
];

export const socialLinks = [
  { key: 'instagram', label: 'Instagram', handle: '@agrarkapital', url: 'https://www.instagram.com/agrarkapital/', icon: Instagram, text: 'Reels aus Acker, Wald und Hofstelle – faceless erklärt, echte Objekte, ehrliche Einblicke.' },
  { key: 'facebook', label: 'Facebook', handle: 'AgrarKapital', url: 'https://www.facebook.com/p/AgrarKapital-61581988246068/', icon: Facebook, text: 'Neue Flächen, Marktnews und Termine – für Eigentümer und Käufer in der Region.' },
  { key: 'youtube', label: 'YouTube', handle: '@agrarkapital', url: 'https://www.youtube.com/@agrarkapital', icon: Youtube, text: 'Kurzvideos: Was eine Fläche wirklich wert macht.' },
  { key: 'linkedin', label: 'LinkedIn', handle: 'AgrarKapital', url: 'https://www.linkedin.com/company/agrarkapital', icon: Linkedin, text: 'Marktwissen und Fachbeiträge zu Agrarimmobilien.' }
];

export const WHATSAPP_CHANNEL_URL = 'https://whatsapp.com/channel/0029VbAjAglATRSetGD53E0J';

// Community-Kanäle (Links bei Bedarf anpassen)
export const communityLinks = [
  { key: 'whatsapp-channel', label: 'AgrarKapital WhatsApp-Kanal', url: 'https://whatsapp.com/channel/0029VbAjAglATRSetGD53E0J', icon: MessageCircle, text: 'Neue Flächen, Marktwissen und Termine direkt aufs Handy – kostenlos abonnieren.' },
  { key: 'whatsapp', label: 'Jetzt per WhatsApp Bewertung anfragen', url: contactInfo.whatsappLink, icon: MessageCircle, text: 'Landkreis, Flächenart und ein Foto der Flurkarte genügen. Direkt, ehrlich, unkompliziert.' }
];

// Elfsight Instagram-Feed Widget-ID (aus dem Elfsight-Konto, Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx). Leer = Platzhalter.
export const INSTAGRAM_WIDGET_ID = '3b3f3e95-92e1-404f-8078-a4df502e1757';
// Elfsight Google-Reviews Widget-ID (optional, nur Fallback wenn keine kuratierten Bewertungen vorliegen)
export const GOOGLE_REVIEWS_WIDGET_ID = '';
export const GOOGLE_REVIEWS_URL = 'https://www.google.com/maps/search/?api=1&query=Heinrichs+Immobilien+Rindermarkt+8+85354+Freising';
export const HERO_VIDEO = { src: '/media/hero-drone.mp4', poster: '/media/hero-drone-poster.jpg' };
